<template>
    <div class="w-full h-full">
        <form @submit.prevent="editPayment" class="flex flex-col justify-between h-full w-full p-2" action="">
            <div class="p-2 flex flex-col">
                <div class="flex flex-col h-full justify-between">
                    <div class="flex flex-col mb-1">
                        <label class="tracking-widest text-gray-500" for="">Payment Date*</label>
                        <input type="date" required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="paymentData.payment_date">
                    </div>
                    <div class="flex flex-col mb-1">
                        <label class="tracking-widest text-gray-500" for="">Status*</label>
                        <select required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="paymentData.status">
                            <option value="pending">Pending</option>
                            <option value="paid">Paid</option>
                            <option value="lost">Lost</option>
                        </select>
                    </div>
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Payment Description*</label>
                        <textarea  required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="paymentData.contingency_description"></textarea>
                    </div>
                </div>
            </div>
            <div class="w-full flex justify-center space-x-2">
                <base-button-affirmative>Save</base-button-affirmative>
                <base-button-negative @click.prevent="close">Cancel</base-button-negative>
            </div>
        </form>
    </div> 
</template>

<script setup>
import { ref, defineProps, defineEmits, reactive } from 'vue';
import { useStore } from 'vuex';
import { updateContingencyPayment } from '@/services/ContingencyPayment';
import { useToast } from 'vue-toast-notification';

const props = defineProps([
    'payment'
])
const store = useStore()
const $toast = useToast()
const emit = defineEmits(['close', 'refetch-payments'])

function close(){
    emit('close')
}

async function editPayment(){
    const token = store.state.auth.token
    const result = await updateContingencyPayment(token, props.payment.id, paymentData)
    if(result.status == 200){
        emit('refetch-payments')
        $toast.open({
            message: 'Successfully updated contingency payment',
            type: 'success',
            duration: 3000
        })
        close()
    } else {
        $toast.open({
            message: 'Error, could not update contingency payment',
            type: 'error',
            duration: 3000
        })
    }
}

const paymentData = reactive({
    payment_date: props.payment.payment_date,
    contingency_description: props.payment.contingency_description,
    status: props.payment.status
})


</script>